// extracted by mini-css-extract-plugin
module.exports = {"smallBtn":"smallBtn_smallBtn__3g9KL"};